// Typelizer digest 6bce33d5b4dff0b18d0a4d5c1224262d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /c/:company_id/invoices */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/invoices', {}, options),
    method: 'get',
  }),

  /** POST /c/:company_id/invoices */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/invoices', {}, options),
    method: 'post',
  }),

  /** GET /c/:company_id/invoices/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/invoices/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /c/:company_id/invoices/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/invoices/:id', params, options),
    method: 'get',
  }),

  /** PATCH /c/:company_id/invoices/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/invoices/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/invoices/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/invoices/:id', params, options),
    method: 'delete',
  }),
}
